export default {
  name: null,
  role: null,
  parent: null,
  groups: [],
};
